import { isNil } from 'ramda';
import * as React from 'react';

import styles from './ExtraVillages.css';
import { RUBLE_SYMBOL } from '../../constants';
import { VILLAGE_CARD_ROUTE } from '../../routes';
import { IRelatedVillageSchema, IRoadInfoSchema } from '../../types';
import { formatNumber, generateHighwayDescription, truncateText } from '../../utils/helpers';

export interface IExtraVillageProps {
  village: IRelatedVillageSchema;
  regionId?: number;
  highway: IRoadInfoSchema | null;
  onVillageLinkClick(): void;
}

export const ExtraVillage = ({ highway, village, regionId, onVillageLinkClick }: IExtraVillageProps) => (
  <li key={village.id} className={styles['list-item']}>
    <a
      href={village.seo ? village.seo.url : `${VILLAGE_CARD_ROUTE}${village.id}`}
      onClick={onVillageLinkClick}
      target="_blank"
    >
      <div className={styles['list-item_image-container']}>
        <img className={styles['list-item_image']} alt={village.name} src={village.imageUrl} />
      </div>
      <span className={styles['list-item_link']}>КП {truncateText(village.name, 37)}</span>
    </a>
    {highway && !isNil(regionId) && (
      <p className={styles['list-item_address']}>{generateHighwayDescription(highway, regionId)}</p>
    )}
    {!village.isCropped && village.priceMin && (
      <strong className={styles['list-item_price']}>
        от {` ${formatNumber(Number(village.priceMin))} ${RUBLE_SYMBOL}`}
      </strong>
    )}
  </li>
);
